import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const MoodIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M17.1 4.4c-.8-1.6-2.2-2.7-3.9-3.2C10 .4 6.7 2.3 5.9 5.5c-2 .1-3.6 1.7-3.6 3.7 0 .4.2.8.5 1.2.3.3.7.5 1.2.5h16c.8 0 1.5-.7 1.6-1.5V9c.1-2.5-1.9-4.6-4.5-4.6z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M11.1 17.3c-.4-1.9-2.7-3-3.4-4.3 0 1.5-1.6 3.5-1.1 5.4.2 1.3 1.4 2.2 2.7 2 .1 0 .2 0 .3-.1 1.2-.4 1.9-1.7 1.5-2.9.1 0 .1-.1 0-.1z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M19.2 19.9c-.5-2.1-2.9-3.3-3.7-4.6 0 1.5-1.7 3.7-1.2 5.6.2 1.4 1.5 2.3 2.8 2.1.2 0 .3-.1.4-.1 1.3-.4 2.1-1.7 1.7-3z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconBase>
  );
};

export default MoodIcon;
